import type { Lens } from '@dhmk/zustand-lens';

import type { OpportunitySummary } from '@/clients/portalAuth/types';
import type { BatteryProducts, MonthlyDetails } from '@/types/battery/battery';

export type BatteryEcommState = {
  selectedOpportunity: OpportunitySummary | undefined;
  products: BatteryProducts | undefined;
  selectedQuantity: number | undefined;
  selectedPricingDetails: MonthlyDetails | undefined;
};

export type BatteryEcommActions = {
  setSelectedOpportunity: (opportunity: OpportunitySummary) => void;
  setProducts: (products: BatteryProducts) => void;
  setSelectedQuantity: (quantity: number) => void;
  setSelectedPricingDetails: (pricingDetails: MonthlyDetails) => void;
};

export type BatteryEcommSlice = BatteryEcommState & {
  actions: BatteryEcommActions;
};

const defaultValues: BatteryEcommState = {
  selectedOpportunity: undefined,
  products: undefined,
  selectedQuantity: undefined,
  selectedPricingDetails: undefined,
};

const sliceName = 'batteryEcomm';

export const createBatteryEcommSlice: Lens<BatteryEcommSlice> = (set) => ({
  ...defaultValues,
  actions: {
    setSelectedOpportunity: (selectedOpportunity) =>
      set(
        { selectedOpportunity },
        undefined,
        `${sliceName}/setSelectedOpportunity`
      ),
    setProducts: (products) =>
      set({ products }, undefined, `${sliceName}/setProducts`),
    setSelectedQuantity: (quantity) =>
      set(
        { selectedQuantity: quantity },
        undefined,
        `${sliceName}/setSelectedQuantity`
      ),
    setSelectedPricingDetails: (selectedPricingDetails) =>
      set(
        { selectedPricingDetails },
        undefined,
        `${sliceName}/setSelectedPricingDetails`
      ),
  },
});
